// 🔧 car_show_entry_generator.js
// ✅ Purpose: Generates realistic Car Show demo entries for the LGV Seed Engine
// ✅ Features:
// - Creates richer vehicle entry seed data
// - Includes registration numbers, years, makes, models, owner names, cities, and descriptions
// - Supports realistic Event Home winner display fields
// - Supports public entry detail pages
// - Future-ready for AI-generated vehicle stories and image selection
// - Fully block-commented for clarity and future devs
import { generateImagesForEntry } from "./image_generator";
import { generateRegistrationNumber } from "./registration_generator";
import { generateOwner } from "./owner_generator";
import { generateSocialLinks } from "./social_generator";
import { generateDescription } from "./description_generator";
import { getIndustryTemplate } from "../industries";

export const generateCarShowEntries = ({
  count = 10,
  categories = [],
} = {}) => {
  return Array.from({ length: count }, (_, index) => {
    const industry =
    getIndustryTemplate(
        "car_show"
    );

    const baseEntry =
    industry.entries[
        index %
        industry.entries.length
    ];

    const title =
      `${baseEntry.year} ${baseEntry.make} ${baseEntry.model}`;

    const rawCategory =
      categories[index % Math.max(categories.length, 1)] ||
      "Classic Cars";

    const category =
      typeof rawCategory === "string"
        ? rawCategory
        : rawCategory?.name || "Classic Cars";

    const regcnt =
      generateRegistrationNumber({
        industryKey: "car_show",
        index,
      });

    const description =
    generateDescription({
        baseDescription:
        baseEntry.description,

        color:
        baseEntry.color,
    });

    const ownerData =
    generateOwner({
        index,
    });

    const imageData = generateImagesForEntry({
      entry: {
        title,
      },

      industryKey: "car_show",
    });

    return {
      demoSeed: true,

      regcnt,

      title,

      name: title,

      year:
        baseEntry.year,

      make:
        baseEntry.make,

      model:
        baseEntry.model,

      color:
        baseEntry.color,

        ownerName:
        ownerData.ownerName,

        ownerFirstName:
        ownerData.ownerFirstName,

        ownerLastName:
        ownerData.ownerLastName,

        ownerCity:
        ownerData.ownerCity,

        ownerState:
        ownerData.ownerState, 

      categoryName:
        category,

        description,

        socialLinks:
        generateSocialLinks({
            seed: title,
        }),

      imgUrl:
        imageData.thumbnail,

      imageUrl:
        imageData.thumbnail,

      images:
        imageData.gallery,

      imagePlaceholder:
        imageData.placeholder,

      imageSource:
        imageData.source,

      imageAltText:
        imageData.altText,

      displayOrder:
        index + 1,
    };
  });
};